module.exports = __webpack_public_path__ + "static/media/43_tn.f2bfac73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/43_tn.jpg
// module id = 531
// module chunks = 0